import api, { ApiResponse } from "../api";
import { OperationsReviewWorkItemRequest, OperationsReviewListResponse, OperationsReviewSummaryResponse, ShipmentWorkItemAccessorialsResponse, OperationsAccessorialApprovalRequest, OperationsAccessorialApprovalResponse, BillingReviewWorkItemRequest, BillingReviewSummaryResponse, BillingReviewListResponse, BillingAccessorialApprovalRequest, BillingAccessorialApprovalResponse, ShipmentWorkItemAccessorialsRequest, AccessorialReviewTerminalPerformanceRequest, AccessorialReviewTerminalPerformanceResponse, AccessorialReviewPerformanceSummary, AccessorialRevenueTrendRequest, AccessorialReviewDailyTrendResponse, AccessorialRevenueTrendIndicators } from "./models";

class ShipmentReconciliationService {
  private source: any;
  private static instance: ShipmentReconciliationService;

  private constructor() { }

  static getInstance(): ShipmentReconciliationService {
    if (!ShipmentReconciliationService.instance) {
      ShipmentReconciliationService.instance = new ShipmentReconciliationService();
    }
    return ShipmentReconciliationService.instance;
  }

  public getOperationsReviewSummary = async (
    requestData: OperationsReviewWorkItemRequest
  ): Promise<ApiResponse<OperationsReviewSummaryResponse>> => {
    return await api.get(
      "/shipment-reconciliation/shipment-work-items/summary/operaions-review",
      { params: requestData }
    );
  };

  public getOperationsReviewList = async (
    requestData: OperationsReviewWorkItemRequest
  ): Promise<ApiResponse<OperationsReviewListResponse>> => {
    return await api.get(
      "/shipment-reconciliation/shipment-work-items/list/operaions-review",
      { params: requestData }
    );
  };

  public getShipmentWorkItemAccessorialsList = async (
    shipmentWorkItemId: number,
    requestData: ShipmentWorkItemAccessorialsRequest
  ): Promise<ApiResponse<ShipmentWorkItemAccessorialsResponse>> => {
    return await api.get(
      `/shipment-reconciliation/shipment-work-items/${shipmentWorkItemId}/accessorials`,
      { params: requestData }
    );
  };

  public submitOperationsAccessorialApproval = async (
    shipmentWorkItemId: number,
    accessorialId: string,
    requestData: OperationsAccessorialApprovalRequest
  ): Promise<ApiResponse<OperationsAccessorialApprovalResponse>> => {
    return await api.post(
      `/shipment-reconciliation/shipment-work-items/${shipmentWorkItemId}/accessorials/${accessorialId}/operations-approval`,
      requestData
    );
  };

  public getBillingReviewSummary = async (
    requestData: BillingReviewWorkItemRequest
  ): Promise<ApiResponse<BillingReviewSummaryResponse>> => {
    return await api.get(
      "/shipment-reconciliation/shipment-work-items/summary/billing-review",
      { params: requestData }
    );
  };

  public getBillingReviewList = async (
    requestData: BillingReviewWorkItemRequest
  ): Promise<ApiResponse<BillingReviewListResponse>> => {
    return await api.get(
      "/shipment-reconciliation/shipment-work-items/list/billing-review",
      { params: requestData }
    );
  };

  public submitBillingAccessorialApproval = async (
    shipmentWorkItemId: number,
    accessorialId: string,
    requestData: BillingAccessorialApprovalRequest
  ): Promise<ApiResponse<BillingAccessorialApprovalResponse>> => {
    return await api.post(
      `/shipment-reconciliation/shipment-work-items/${shipmentWorkItemId}/accessorials/${accessorialId}/billing-approval`,
      requestData
    );
  };

  public getOperationsReviewListExport = async (
    requestData: OperationsReviewWorkItemRequest
  ): Promise<ApiResponse<any>> => {
    return await api.get(
      "/shipment-reconciliation/shipment-work-items/list/operaions-review/export",
      { params: requestData }
    );
  };

  public getAccessorialReviewTerminalPerformance = async (
    requestData: AccessorialReviewTerminalPerformanceRequest
  ): Promise<ApiResponse<AccessorialReviewTerminalPerformanceResponse>> => {
    return await api.get(
      "shipment-reconciliation/analytics/accessorial-review/terminal-performance",
      { params: requestData }
    );
  };

  public getBillingReviewListExport = async (
    requestData: BillingReviewWorkItemRequest
  ): Promise<ApiResponse<any>> => {
    return await api.get(
      "/shipment-reconciliation/shipment-work-items/list/billing-review/export",
   { params: requestData }
    );
  };

public getAccessorialReviewPerformanceSummary = async (
    requestData: AccessorialReviewTerminalPerformanceRequest
  ): Promise<ApiResponse<AccessorialReviewPerformanceSummary>> => {
    return await api.get(
      "shipment-reconciliation/analytics/accessorial-review/performance/summary",
      { params: requestData }
    );
  };

  public getAccessorialRevenueDailyTrend = async (
    requestData: AccessorialRevenueTrendRequest
  ): Promise<ApiResponse<AccessorialReviewDailyTrendResponse>> => {
    return await api.get(
      "shipment-reconciliation/analytics/financial-insights/daily-trend",
      { params: requestData }
    );
  };

  public getAccessorialRevenueTrendIndicators = async (
    requestData: AccessorialRevenueTrendRequest
  ): Promise<ApiResponse<AccessorialRevenueTrendIndicators>> => {
    return await api.get(
      "shipment-reconciliation/analytics/financial-insights/trend-indicators",
      { params: requestData }
    );
  };
}

export default ShipmentReconciliationService;